(ns ycweb.app.pos.merchandising.merchandising
  (:require
   [rum.core :as rum]
   [ycweb.components.forms :as forms]
   [ycweb.components.buttons :as buttons]
   [ycweb.util.core :as u]
   [ycweb.components.grid :as grid]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.transitions :as t]
   [ycweb.components.toaster :as toaster]
   [ycweb.util.comms :as comms]
   [ycweb.components.wrapper :as w]
   [ycweb.app.dashboard.presence :as presence]))

(def monthly-steps
  (forms/setup-steps
    [{:key :choose-type :title "Merchandising Type"}
     {:key :bay-list :title "List of Bays to Photograph"}
     {:key :bay :title "Take Photo"}]))

(defmethod comms/receive :merchandising/image-uploaded [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (swap!
    (rum/cursor-in app-atom [:merchandising :bay :images])
    (fn [c] (cons e c)))
  (t/transition-next app-atom :merchandising/bay))

(defmethod grid/action :merchandising/image [app-atom config _]
  (toaster/open-subtle-progress app-atom)
  (let [bay-uuid (cmn/curact app-atom [:merchandising :bay :uuid])
        attachment-uuid (u/uuid)]
    (presence/upload-file
      {:filename "store-bay-image.png"
       :filecontents (:baos config)
       :type :store/bay}
      {:response :merchandising/image-uploaded}
      attachment-uuid
      bay-uuid)))

(defmethod comms/receive :merchandising/remove-image [app-atom {:keys [removed-uuid]}]
  (toaster/close-subtle-progress app-atom)
  (let [images-atom (rum/cursor-in app-atom [:merchandising :bay :images])]
    (swap!
      images-atom
      (fn [imgs]
        (remove #(= (:ent/uuid %) removed-uuid) imgs)))))

(defmethod grid/action :merchandising/remove-image [app-atom {:keys [remove-uuid]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :presence/remove-attachment
    {:uuid remove-uuid :response :merchandising/remove-image}))

(rum/defc discard-modal-footer < rum/reactive [app-atom config-atom]
  (grid/button-row
    {:left-text "Cancel"
     :left-no-icon true
     :left-fn #(grid/dispatch-modal-action app-atom :merchandising/discard-cancel)
     :right-text "Discard"
     :right-style :negative
     :right-no-icon true
     :right-fn
     #(grid/dispatch-modal-action app-atom :merchandising/remove-image
        {:remove-uuid (:remove-uuid config-atom)})}))

(rum/defc discard-modal-body < rum/reactive [app-atom config-atom]
  (list
    [:h3
     {:class (u/bem :heading [:medium-large])}
     "Discard this image?"]
    [:p.paragraph "This action cannot be undone."]))

(defmethod grid/modal-config :merchandising/discard-modal [_ _ _]
  {:body discard-modal-body
   :footer discard-modal-footer
   :modal-type :alert})

(rum/defc bay < rum/reactive [app-atom]
  (let [bay (cmn/curact app-atom [:merchandising :bay])
        images (:images bay)]
    (w/wrapper app-atom "Merchandising" {:steps monthly-steps :step :bay}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Photograph Bay"]]
       [:div.form-field.u-text-center
        (buttons/button "Take Pictures of the Bay"
          #(grid/dispatch-action app-atom :camera/capture-start
             {:callback-action :merchandising/image})
          {:secondary true
           :bordered true
           :large true
           :center true
           :icon-left :camera})]
       [:div.form-field
        (when-not (empty? images)
          [[:label.form-label
            "Captured pictures:"]
           (into
             [:div.flex-grid-group
              {:class (u/bem :flex-grid-group [:flush :align-left])}]
             (map
               (fn [{:keys [ent/uuid doc/public-id doc/file-name]}]
                 [:div
                  {:class (u/bem :flex-grid-block [:m-1-4 :t-1-2])}
                  [:div.flex-grid-content
                   [:img
                    {:class (u/bem :image [:full])
                     :on-click
                     #(grid/open-modal app-atom :merchandising/discard-modal {:remove-uuid uuid})
                     :src
                     (u/cloudinary
                       public-id
                       {:h 128
                        :q "auto"
                        :f "auto"}) :alt file-name}]]])
               images))])]]
      [[:aside.page-body__footer
        [:p.u-text-center
         {:class (u/bem :paragraph [:flush])}
         "When happy with the photos go to next bay"]]]
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Next Bay"
         :right-fn
         (when-not (empty? images)
           #(grid/dispatch-action app-atom :merchandising/bay-list {}))}))))

(defmethod flow/render-screen :merchandising/bay [app-atom screen]
  (bay app-atom))

(defmethod comms/receive :merchandising/bay-scan [app-atom {:keys [bay]}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom assoc-in [:merchandising :bay] bay)
  (t/transition-next app-atom :merchandising/bay))

(defmethod grid/action :merchandising/bay-scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :merchandising/bay-scan
    {:scan scan}))

(defmethod flow/barcode-dispatch-screen :merchandising/bay-list [_ app-atom scan]
  (grid/dispatch-action app-atom :merchandising/bay-scan {:scan scan}))

(defmethod grid/action :merchandising/bay-list-menu-barcode [app-atom config _]
  (grid/single-input-modal app-atom
    {:title "Capture manual barcode"
     :field-text "Barcode"
     :initial-value ""
     :save-text "Capture"
     :save-key :merchandising/bay-scan
     :input-key :scan
     :input-type :barcode}))

(defn bay-list-menu-modal [app-atom]
  (grid/menu-modal app-atom
    {:items
     [{:label "Refresh"
       :action :merchandising/bay-list}

      {:label "Manual Barcode"
       :action :merchandising/bay-list-menu-barcode}

      {:label "Cancel"
       :action :merchandising/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(rum/defc bay-list < rum/reactive [app-atom]
  (let [bay-list (cmn/curact app-atom [:merchandising :bay-list])]
    (w/wrapper app-atom "Merchandising" {:modal-fn bay-list-menu-modal :steps monthly-steps :step :bay-list}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         (str (count bay-list) " Bay" (when (> (count bay-list) 1) "s") " to Photograph")]]
       (into [:div.slats]
         (for [bay bay-list]
           [:article.slat.transfer-order-slat
            [:header.transfer-order-slat__header
             [:div.transfer-order-slat__title-wrapper
              [:h1.transfer-order-slat__title
               [:span.transfer-order-slat__order-no (str "Bay " (:baynumber bay))]
               [:span.transfer-order-slat__user
                (:description bay)]]]]]))]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Scan Bay"
         :right-plain true}))))

(defmethod flow/render-screen :merchandising/bay-list [app-atom screen]
  (bay-list app-atom))

(defmethod comms/receive :merchandising/bay-list [app-atom {:keys [bay-list] :as e}]
  (toaster/close-toast app-atom)
  (swap! app-atom assoc-in [:merchandising :bay-list] bay-list)
  (t/transition-next app-atom :merchandising/bay-list))

(defmethod grid/action :merchandising/bay-list [app-atom config _]
  (toaster/open-toast app-atom :processing "Loading bays to photograph" {})
  (comms/send :merchandising/bay-list {}))

(rum/defc choose-type < rum/reactive [app-atom]
  (w/wrapper app-atom "Merchandising" {:steps monthly-steps :step :choose-type}
    [[:div.section
      [:h2.u-text-center
       {:class (u/bem :heading [:standard])}
       "Choose Merchandising Type"]
      [:a.card.tile.u-angled-background.u-bg-teal-blue.u-min-height-160
       {:on-click
        #(grid/dispatch-action app-atom :merchandising/bay-list {})}
       [:span.tile__content
        [:span.tile__icon-wrapper
         [:i.tile__icon
          {:class (u/bem :icon [:2-2 :return :large :block])}]]
        [:span.tile__text "Monthly Photos"]]]
      [:a.card.or-card.tile.u-angled-background.u-bg-deep-purple.u-min-height-160
       {:class (u/bem :card [:is-disabled] :tile [:is-disabled])}
       #_{:on-click
          #(t/transition-next app-atom :merchandising/campaign-selection)}
       [:span.tile__content
        [:span.tile__icon-wrapper
         [:i.tile__icon
          {:class (u/bem :icon [:2-2 :price-tag :large :block])}]]
        [:span.tile__text "Campaign Photos"]]]]]
    []
    (grid/pos-call-to-action
      {:left-fn #(t/transition-next app-atom :main-menu)
       :right-plain true})))

(defmethod flow/render-screen :merchandising/choose-type [app-atom screen]
  (choose-type app-atom))